<template>
  <v-snackbar
    v-model="active"
    :color="status"
    timeout="-1"
    right
    bottom
    v-click-outside="clickOutside"
    class="ml-4"
    elevation="24"
    transition="fade-transition"
  >
    <div v-for="message in messages" :key="message">
      <span class="font-weight-bold" style="font-size: 16px">{{ message }}</span>
    </div>
    <div v-if="text_link && link" class="mt-3">
      <v-btn outlined @click="openRequestOrTicket">
        {{text_link}}
      </v-btn>
    </div>
    <template v-slot:action>
      <v-btn icon small @click="active = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'PopupErrorBtnComponent',
  data() {
    return {
      active: false,
      text: "",
      messages: [],
      message: "",
      status: "success",
      link: null,
      copy: null,
      text_link: null,
      CurrentRole:0,
    };
  },
  computed: {
    copyText() {
      if (typeof this.copy != 'object') {
        return this.copy
      }
      return this.copy.content
    },
    hrefTarget () {
      return (this.link.newTap ? "_blank" : "_self")
    },

  },
  created() {},
  mounted() {
    this.CurrentRole = window.localStorage.getItem("role");
    this.$root.$on("popup-btn", (status, text,text_link=null, link = null) => {
      this.active = true;
      this.text = text;
      this.status = status;
      this.messages = this.text.split("\n");
      this.link = link;
      this.text_link = text_link;
    });
  },
  methods: {
    clickOutside() {
      this.$nextTick(() => {
        this.active = false;
      });
    },

    openRequestOrTicket(){
      this.active = false;
      if(this.text_link == "فتح التذكرة"){
        this.$router.push({
          name: this.ticketDetailsRouteName(),
          params: { ticket: this.link },
        });
      } else if(this.text_link == "فتح الطلب"){
        this.$router.push({
          name: this.requestDetailsRouteName(),
          params: { id: this.link },
        });
      } else if(this.text_link == "فتح الاستبيان"){
        this.$router.push({ name: 'questionnaire_details', params: { id: this.link } });
      }
    },

    ticketDetailsRouteName() {
      const routes = {
        "1": "salesManager_ticket_details",
        "5": "quality_tickets_details",
        "7": "admin_tickets_details",
      };

      return routes[this.CurrentRole] || "ticket_details";
    },

    requestDetailsRouteName() {
      const routes = {
        "1": "salesManager_request_details",
        "5": "quality_request_details",
      };

      return routes[this.CurrentRole] || "request_details";
    },
  },
};
</script>
